
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14.972","fill":"#3d9ed3"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-6 -6.028)"}},[_c('rect',{attrs:{"data-name":"Rectangle 426","width":"14","height":"2","rx":"1","transform":"translate(6 19)"}}),_c('rect',{attrs:{"data-name":"Rectangle 427","width":"4","height":"2","rx":"1","transform":"rotate(-90 13.5 7.5)"}}),_c('rect',{attrs:{"data-name":"Rectangle 428","width":"4","height":"2","rx":"1","transform":"rotate(-90 19.5 1.5)"}}),_c('path',{attrs:{"data-name":"Path 7112","d":"M13 16.581a.879.879 0 01-.51-.158l-3.516-2.484a.88.88 0 111.02-1.433l3.006 2.1 2.989-2.25a.879.879 0 111.055 1.406l-3.516 2.637a.879.879 0 01-.527.176z"}}),_c('path',{attrs:{"data-name":"Path 7113","d":"M13 14.818a.879.879 0 01-.879-.879V6.907a.879.879 0 011.758 0v7.032a.879.879 0 01-.879.879z"}})])])
          )
        }
      }
    